import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { Printers } from "../pages/api";

const initialState: Printers = {
  list: [],
  isLoading: false,
  printingList: [],
};

export const printersSlice = createSlice({
  name: "printers",
  initialState,
  reducers: {
    addPrinter: (state: any, action: PayloadAction<any>) => {
      state.list = [action.payload, ...state.list];
    },
    setPrinters: (state: any, action: PayloadAction<Array<any>>) => {
      state.list = action.payload;
    },
    setIsPrintersLoading: (state: any, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    addToPrintingList: (state: any, action: PayloadAction<any>) => {
      state.printingList = [action.payload, ...state.printingList];
    },
    removeFromPrintingList: (state: any, action: PayloadAction<any>) => {
      state.printingList = state.printingList.filter(
        (p: any) => p.id !== action.payload
      );
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  addPrinter,
  setPrinters,
  setIsPrintersLoading,
  addToPrintingList,
  removeFromPrintingList,
} = printersSlice.actions;

export default printersSlice.reducer;
